"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BellOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var BellOutlineSVG = function BellOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M24.36,12.54A8.53,8.53,0,0,0,17,4.07S17,4,17,4V3a1,1,0,0,0-2,0V4s0,0,0,.06a8.29,8.29,0,0,0-7.37,8.19c0,8.23-4.64,6.47-4.64,11v.92A1.84,1.84,0,0,0,4.86,26h7.69a4,4,0,0,0-.05.5,3.5,3.5,0,0,0,7,0,4,4,0,0,0-.05-.5h7.69A1.84,1.84,0,0,0,29,24.17v-.92C29,18.77,24.47,20.44,24.36,12.54Zm-6.86,14a1.5,1.5,0,0,1-3,0,1.64,1.64,0,0,1,.09-.5h2.82A1.64,1.64,0,0,1,17.5,26.5ZM27,24H5v-.75c0-1.06.3-1.34,1.18-2.17C8,19.37,9.64,17.41,9.64,12.25A6.31,6.31,0,0,1,16,6l.56,0a6.57,6.57,0,0,1,5.8,6.54c.07,5.35,2,7.18,3.46,8.52.88.83,1.18,1.11,1.18,2.17Z"
  }));
};
exports.BellOutlineSVG = BellOutlineSVG;
BellOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BellOutlineSVG);
exports.default = _default;